import { REPORTS_TYPES } from 'constants/report';
import callAPiBase from './base';

const printModelApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/printModelList',
      method: 'GET',
      useToken: true,
      title: 'Print Model - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/printModelCreate',
      method: 'POST',
      useToken: true,
      title: 'Print Model - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/printModelUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Print Model - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/printModelDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Print Model - Delete',
      params,
    }),
};

export { printModelApi };
export default printModelApi;
